module.exports = {"id":"214190","name":"Leandro Castellanos","rating":"73","photo":"./data/images/photos/1/214190.png","club":{"name":"Ind. Santa Fe","logo":"./data/images/clubs/Ind.SantaFe.png"},"positions":["G"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/LeandroCastellanos0.json
// module id = 2451
// module chunks = 0